import React from 'react';
import PropTypes from 'prop-types';
import { FDStack } from '@facet-wealth/design';

const TableCellContent = ({ children }) => {
  return <FDStack alignItems={'center'} justifyContent={'flex-end'} width={'85px'}>{children}</FDStack>;
};

TableCellContent.defaultProps = {};

TableCellContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default TableCellContent;
